'use client';

import { useState } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { useClientTranslation } from '@bts-web/utils-lokalise';
import { DialogBase } from '../../../DialogBase/DialogBase';
import { TwoFaLayoutWrapper } from '../shared/TwoFaLayoutWrapper';
import { TwoFaSectionDescription } from '../shared/TwoFaSectionDescription';
import { TwoFaSectionTitle } from '../shared/TwoFaSectionTitle';
import { TwoFaSectionButtonsWrapper } from '../shared/TwoFaSectionButtonsWrapper';
import { ButtonBase } from '../../../ButtonBase/ButtonBase';
import { signOutForTwoFaSetup } from '../../../../../auth';
import { ModalComponent } from '../../../ModalDrawerContext/ModalDrawerContext';
import { TwoFaContentWrap } from '../shared/TwoFaContentWrap';

export type TriggerSetupTwoFaModalProps = {
  onModalClose?: () => void;
};

const TriggerSetupTwoFaModal: ModalComponent<TriggerSetupTwoFaModalProps> = ({
  onClose,
  onModalClose,
}) => {
  const [loading, setLoading] = useState(false);

  const { t } = useClientTranslation();

  const triggerSetupTwoFaLogout = async () => {
    setLoading(true);

    try {
      await signOutForTwoFaSetup();

      return;
    } catch (_error) {
      setLoading(false);
    }
  };

  const onClickClose = () => {
    if (onModalClose) {
      onModalClose();
    }

    onClose();
  };

  return (
    <DialogBase
      id="trigger-reset-2fa-modal"
      onClose={onClickClose}
      size="medium"
      visual="secondary"
      title={t('2fa_welcome_title')}
      onMobileFullScreen
      contentProps={{
        disableContentPadding: true,
      }}
      showHeaderBottomDivider
    >
      <TwoFaLayoutWrapper>
        <TwoFaContentWrap>
          <TwoFaSectionTitle title={`${t('2fa_welcome_subtitle')}`} />
          <TwoFaSectionDescription
            textContent={`${t('2fa_reauthenticate_body_@tenant')}`}
          />
        </TwoFaContentWrap>

        <TwoFaSectionButtonsWrapper>
          <ButtonBase
            isLoading={loading}
            onClick={triggerSetupTwoFaLogout}
            visual="primary"
            size="large"
            fullWidth
            disabled={loading}
          >
            {t('2fa_enable_accept_button')}
          </ButtonBase>
          <ButtonBase
            disabled={loading}
            isLoading={loading}
            visual="ghost"
            onClick={onClickClose}
            className={css({
              textDecoration: 'underline',
            })}
          >
            {t('2fa_welcome_cta_skip')}
          </ButtonBase>
        </TwoFaSectionButtonsWrapper>
      </TwoFaLayoutWrapper>
    </DialogBase>
  );
};

export { TriggerSetupTwoFaModal };
